

















































































































import Vue from 'vue'
import helpers from '../../helpers'
import './VideoPlayer.scss'
import ChromaKey from '@/components/ChromaKey'
import ClipLoader from '@/components/vue-spinner/ClipLoader.vue'
import { ChromaKeyPreviewQualityType } from '../../types/users'

export default Vue.extend({
  name: 'VideoPlayer',
  props: {
    streamSrc: {
      type: Object as () => MediaStream
    },
    chromakey: {
      type: Object
    },
    pickingMode: {
      type: Boolean
    },
    debugMode: {
      type: Boolean,
      default: false,
    },
    muted: {
      type: Boolean,
      default: true,
    },
    videoId: {
      type: String
    },
    fullres: {
      type: Boolean,
      required: false,
      default: false
    },
    hideVideo: {
      type: Boolean,
      required: false,
      default: false
    },
    showLoader: {
      type: Boolean,
      required: false,
      default: false
    },
    QAId: {
      type: String,
      required: false,
      default: ''
    }
  },
  computed: {
    chromaKeyEnabled (): boolean {
      if (this.chromakey && this.chromakey.enabled)
        if(this.fullres)
          return true
        else
          return this.$store.direct.state.user.profile?.chromaKeyPreviewQuality !== ChromaKeyPreviewQualityType.Off
      else
        return false
    },
    randStrVid (): string {
      if (this.videoId) {
        return this.videoId
      } else {
        return 'vid' + this.randStr
      }
    } /*,
    videoSrc() {
      console.log(window)
      window.URL.createObjectURL(this.streamSrc)
    }*/
  },
  data: () => ({
    randStr: null as null|string
  }),
  created () {
    this.randStr = helpers.makeId()
  },
  mounted () {
    /*setTimeout(() => {
      console.log('Setting srcObject now', this.$refs.video, this.streamSrc)
      this.$refs.video.srcObject = this.streamSrc.srcObject
    }, 0) */
  },
  methods: {
    colorPicked (pixel) {
      this.$emit('colorPicked', pixel)
    }
  },
  components: {
    ChromaKey,
    ClipLoader
  }
})
